module.exports = __webpack_public_path__ + "static/media/revenue-operations-feature-3.16c763d4.svg";